import { render, staticRenderFns } from "./ShiftsList.vue?vue&type=template&id=7198b282&scoped=true&"
import script from "./ShiftsList.vue?vue&type=script&lang=ts&"
export * from "./ShiftsList.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftsList.vue?vue&type=style&index=0&id=7198b282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7198b282",
  null
  
)

export default component.exports